(() => {
  const STORAGE_KEY = 'flothari_breadcrumb_collection';

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    if (!link) return;

    const section = link.closest('.shopify-section');
    const context = section?.querySelector('[data-breadcrumb-collection-context]');
    if (!context) return;

    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        handle: context.dataset.handle,
        title: context.dataset.title,
        url: context.dataset.url
      })
    );
  });

  const breadcrumb = document.querySelector('[data-breadcrumb]');
  if (!breadcrumb) return;

  const storedValue = sessionStorage.getItem(STORAGE_KEY);
  if (!storedValue) return;

  let stored;

  try {
    stored = JSON.parse(storedValue);
  } catch {
    return;
  }

  if (!stored?.handle) return;

  const handles = (breadcrumb.dataset.collectionHandles || '').split(',').filter(Boolean);
  if (!handles.includes(stored.handle)) return;

  const link = breadcrumb.querySelector('[data-breadcrumb-collection-link]');
  if (!link) return;

  link.href = stored.url;
  link.textContent = stored.title;
})();
